import { render, staticRenderFns } from "./pop-up-ad.vue?vue&type=template&id=33b8d0f6&scoped=true&"
import script from "./pop-up-ad.vue?vue&type=script&lang=js&"
export * from "./pop-up-ad.vue?vue&type=script&lang=js&"
import style0 from "./pop-up-ad.vue?vue&type=style&index=0&id=33b8d0f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b8d0f6",
  null
  
)

export default component.exports